import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SipInfoComponent } from './sip-info.component';



@NgModule({
  declarations: [
    SipInfoComponent
  ],
  imports: [
    CommonModule
  ],
  bootstrap: [SipInfoComponent],
  exports: [SipInfoComponent]
})
export class SipInfoModule {
  getComponent() {
    return SipInfoComponent;
  }
}
